export const msalConfig = {
  auth: {
    clientId: "738f2f43-4889-4eb1-849e-7baf7da702d7",
    authority: "https://login.microsoftonline.com/28b2ab1a-cff1-465a-a0ab-08a73cebefcd", 
    redirectUri: "https://portal.rapidresourcingltd.co.uk/ms/mail/callbaclk",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["Mail.Read", "Mail.Send"],
};
